import { HelpProvider } from './../../providers/help/help';
import { ViewController, LoadingController } from 'ionic-angular';
import { Component } from '@angular/core';
import { FirstPromoterProvider } from '../../providers/first-promoter/first-promoter';

@Component({
  selector: 'affiliate-info',
  templateUrl: 'affiliate-info.html'
})
export class AffiliateInfoComponent {

  constructor(
    public viewCtrl: ViewController,
    public help: HelpProvider,
    public promoter: FirstPromoterProvider
  ) {

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  createPromoter(){
    this.dismiss();
    this.promoter.createPromoter();
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliate-info/affiliate-info.ts